<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">二次报价</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 内容区域 -->
        <div class="content-container">
            <template v-if="!offerConfigList || offerConfigList.length === 0">
                <div class="empty-content">
                    <p>代理未设置二次报价清单或未开始二次报价，请等待专家开启二次报价</p>
                </div>
            </template>
            <template v-else>
                <el-table :data="offerConfigList" border style="width: 100%;">
                    <el-table-column label="投标单位" prop="userName" />
                    <el-table-column label="报价时间" prop="offerTime" />
                    <el-table-column label="报价状态">
                        <template slot-scope="scope">
                            <span>{{ scope.row.isOffered === 1 ? '已报价' : '未报价' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="20">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.isOffered !== 1" type="primary" size="small"
                                @click="handleOffer(scope.row)">报价</el-button>
                            <el-button v-else type="primary" size="small" @click="handleOffer(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
        <el-dialog title="报价" :visible.sync="offerDialogVisible" width="40%" :append-to-body="true">
            <div v-if="list && list.length" style="margin-bottom: 16px;">
                <el-table :data="list" border style="width: 100%;">
                    <el-table-column prop="itemName" label="条目名称" min-width="180" />
                    <el-table-column label="报价值" min-width="180">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.itemValue" size="small" placeholder="请输入报价"
                                :disabled="currentOfferRow && currentOfferRow.isOffered === 1" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-if="isUpload !== 0 && (!currentOfferRow || currentOfferRow.isOffered !== 1)"
                style="margin-bottom: 20px; text-align: left;">
                <el-button type="primary" size="small" @click="handleUploadAttachment">上传附件</el-button>
                <span v-if="attachmentFileName" style="margin-left: 8px; font-size: 12px; color: #666;">{{
                    attachmentFileName
                }}</span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="offerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm" v-if="currentOfferRow.isOffered !== 1">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getOfferConfig, getOfferConfigList, saveOfferAgain } from '@/api/offer/api'
import { doFileUpload } from '@/utils/fileUploadHelper'
import { getBidderFlowTitle } from '@/utils/projectInfo.js'
export default {
    name: 'BidSecondQuotate',
    data() {
        return {
            sectionCode: this.$route.query.sectionCode || '',   // 获取项目编号
            projectTitle: '',
            projectInfo: {
                sectionCode: this.$route.query.sectionCode
            },
            offerConfigList: [],
            offerDialogVisible: false,
            currentOfferRow: {
                isOffered: 1
            },
            list: [],
            isUpload: 0,
            fileBindId: '',
            attachmentFileId: '',
            attachmentFileName: ''
        }
    },
    mounted() {
        this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
        this.initPage()
        this.getProjectInfo()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },
        // 初始化页面
        initPage() {
            this.getOfferConfigList()
        },
        //获取报价配置
        getOfferConfigList() {
            getOfferConfigList(this.projectInfo.sectionCode).then(res => {
                if (res.code === 200) {
                    this.offerConfigList = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        // 获取报价列表
        getOfferConfig() {
            getOfferConfig({ sectionCode: this.projectInfo.sectionCode, offerInfoId: this.currentOfferRow.id }).then(res => {
                if (res.code === 200) {
                    this.list = res.data.list || [];
                    this.isUpload = res.data.isUpload;
                } else {
                    this.offerList = []
                    this.$message.error(res.msg)
                }
            })

        },
        // 上传附件
        async handleUploadAttachment() {
            // 已报价状态下不允许上传附件
            if (this.currentOfferRow && this.currentOfferRow.isOffered === 1) {
                return
            }
            const input = document.createElement('input')
            input.type = 'file'
            input.onchange = async (e) => {
                const file = e.target.files[0]
                if (!file) return
                file.fileType = 'second-quote-att'
                try {
                    const uploadResult = await doFileUpload(file, {
                        fileBindId: this.fileBindId
                    })
                    if (uploadResult && uploadResult.success) {
                        this.attachmentFileId = uploadResult.fileId || uploadResult.uploadFileId || ''
                        this.attachmentFileName = file.name
                        this.$message.success('附件上传成功')
                    } else {
                        this.$message.error(uploadResult?.message || '附件上传失败')
                    }
                } catch (error) {
                    this.$message.error(error.message || '附件上传失败')
                }
            }
            input.click()
        },
        // 报价
        handleConfirm() {
            let data = {
                fileBindId: this.fileBindId,
                list: this.list,
                offerInfoId: this.currentOfferRow.id,
                sectionCode: this.projectInfo.sectionCode,
            }
            if (this.isUpload == 0) {
                delete data.fileBindId
            }
            saveOfferAgain(data).then(res => {
                if (res.code === 200) {
                    this.$message.success('报价成功')
                    this.offerDialogVisible = false
                    this.initPage()
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        handleOffer(row) {
            this.currentOfferRow = row
            this.offerDialogVisible = true
            console.log('--------执行', row);

            this.getOfferConfig()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.empty-content {
    padding: 40px;
    text-align: center;
    color: @gray-500;
    background: @gray-50;
    border: 1px dashed @gray-300;
    border-radius: 8px;
}

/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container {
        padding: 16px;
    }
}

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
}

.content-wrap {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
}

.empty-content {
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
    font-size: 16px;
}
</style>